import { customerTokenHeaders } from './customerTokenApi';
import { getBookingBrowserBase } from './bookingBrowserBase';

export interface CustomerActivityItem {
  id: string;
  createdAt: string;
  module: string;
  eventType: string;
  summary: string;
  payload: Record<string, unknown>;
  read: boolean;
}

export interface CustomerActivityResponse {
  items: CustomerActivityItem[];
  unreadCount: number;
}

export async function fetchCustomerActivity(params: {
  tenantId: string;
  email?: string | null;
  telegramId?: string | null;
  whatsappId?: string | null;
  limit?: number;
  /** Credencial de identidad (B2-1). Sin ella booking-service responde 401. */
  customerToken?: string | null;
}): Promise<CustomerActivityResponse> {
  const base = getBookingBrowserBase();
  const q = new URLSearchParams();
  q.set('tenant_id', params.tenantId);
  if (params.email?.trim()) q.set('email', params.email.trim());
  if (params.telegramId?.trim()) q.set('telegram_id', params.telegramId.trim());
  if (params.whatsappId?.trim()) q.set('whatsapp_id', params.whatsappId.trim());
  if (params.limit) q.set('limit', String(params.limit));
  const path = `/api/v1/bookings/customer/activity?${q.toString()}`;
  const url = base ? `${base}${path}` : path;
  const res = await fetch(url, { headers: customerTokenHeaders(params.customerToken ?? null) });
  if (!res.ok) {
    throw new Error(`activity ${res.status}`);
  }
  return res.json() as Promise<CustomerActivityResponse>;
}
